export default "__VITE_ASSET__B0I2HP35__"